export const fbPixelEvent = {
  methods: {
    leadTracking(data) {
      window.fbq('trackSingle', window.laligaPixel, 'Lead', data);
    },
    customTracking(customName, data) {
      window.fbq('trackSingleCustom', window.laligaPixel, customName, data);
    },
  },
};
